<form [formGroup]="forgot">
  <h5 class="sub-title mb-3">Forgot Password</h5>
  <div class="">
    <mat-form-field class="material-full-width" appearance="outline">
      <mat-label>Enter Your Email<span class="text-danger">*</span></mat-label>
      <input
        matInput
        placeholder="Enter Email ID"
        formControlName="email"
        oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
        [ngClass]="{ 'is-invalid': add.email.touched && add.email.errors }"
      />
      <mat-error *ngIf="add.email.touched && add.email.errors">
        <span *ngIf="add.email.errors.required">Email is required</span>
        <span *ngIf="add.email.errors.email">
          <i class="fas fa-exclamation-triangle"></i>
          Invalid Email
        </span>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="text-center mt-5">
    <button
      class="mr-2 new-btn-color2"
      mat-raised-button
      color="warn"
      (click)="cancelReason()"
    >
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      class="new-btn-color"
      (click)="saveBtn()"
    >
      Submit
    </button>
  </div>
</form>
<div id="reSubmitModal" class="modal">
  <div class="modal-content text-center">
    <div class="text-center">
      <img
        class="image-sec"
        style="width: 130px"
        src="/assets/images/attention -man.gif"
        alt=""
      />
    </div>
    <h3 style="font-size: 22px; font-weight: 500">
      An email has been sent to you with credentials.
    </h3>
    <div class="text-center mt-4">
      <button class="incubatorBtn" (click)="closeModal()">Close</button>
    </div>
  </div>
</div>
